export const filterByPropsName = (list, propsName) => {
  const clonedList = JSON.parse(JSON.stringify(list))
  clonedList.forEach((item, index) => {
    item[propsName] = 0
    item.date = list[index].date
  })
  return clonedList
}

const addSelectedKey = (selectedKeys, value) => {
  if (value !== undefined && value !== null) {
    selectedKeys.add(value)
  }
}

const getSelectedKeys = selectedList => {
  const selectedKeys = new Set()

  selectedList.forEach(item => {
    if (item && typeof item === 'object') {
      if (item.isChecked === false) return

      addSelectedKey(selectedKeys, item.id)
      addSelectedKey(selectedKeys, item.value)
      return
    }

    addSelectedKey(selectedKeys, item)
  })

  return selectedKeys
}

export const markSelectedFilterData = (staticList, selectedList = []) => {
  const selectedKeys = getSelectedKeys(selectedList)

  return staticList.map(item => ({
    ...item,
    isChecked: selectedKeys.has(item.id) || selectedKeys.has(item.value),
  }))
}

const hasSelectedValues = values => Array.isArray(values) && values.length > 0

export const applyPortfolioUserFilters = (
  tickers = [],
  selectedFilter = {},
) => {
  let filteredTickers = tickers

  if (hasSelectedValues(selectedFilter.sector)) {
    filteredTickers = filteredTickers.filter(ticker =>
      selectedFilter.sector.includes(ticker.factset_sector_desc),
    )
  }

  if (hasSelectedValues(selectedFilter.industry)) {
    filteredTickers = filteredTickers.filter(ticker =>
      selectedFilter.industry.includes(ticker.industry),
    )
  }

  if (hasSelectedValues(selectedFilter.region)) {
    filteredTickers = filteredTickers.filter(ticker =>
      selectedFilter.region.includes(ticker.region),
    )
  }

  if (hasSelectedValues(selectedFilter.country)) {
    filteredTickers = filteredTickers.filter(ticker =>
      selectedFilter.country.includes(ticker.iso_country),
    )
  }

  if (selectedFilter.searchByWord?.trim()) {
    const searchLower = selectedFilter.searchByWord.trim().toLowerCase()
    filteredTickers = filteredTickers.filter(
      ticker =>
        ticker.proper_name?.toLowerCase().includes(searchLower) ||
        ticker.ticker?.toLowerCase().includes(searchLower),
    )
  }

  return filteredTickers
}

export const applyPortfolioRiskFilter = (
  tickers = [],
  activeNode,
  riskType,
) => {
  if (!activeNode?.name || activeNode.name === 'total') {
    return tickers
  }

  return tickers.filter(ticker =>
    riskType === 'CREDIT'
      ? ticker.credit_status === activeNode.name
      : ticker.risk_outlook === activeNode.name,
  )
}
